<template>
	<div>
		<v-dialog v-model="dialog_tax_update" v-if="dialog_tax_update" persistent no-click-animation z-index="9999" transition="slide-y-transition" max-width="320">
	      <v-card>
			<v-card-title class="title noshadow font18">
				Tax Update
	      	</v-card-title>

	        <v-card-text class="pt-2">
               <p font16>Selected tax category is reform now. Consider updating tax category of item as per applicable tax forms.</p>	
               <v-checkbox font12 label="Do not show this message again" v-model="doNotShowAgain"></v-checkbox>			
	        </v-card-text>
			<v-divider></v-divider>
	        <v-card-actions style="padding:6px 0px;">
				  <v-layout row wrap>
	        		<v-flex xs6 sm6 md6 center-align style="border-right:1px #ddd solid">
	        			<v-btn small font-heavy light-opacity-color flat @click="$parent.fn_closeDialog">Cancel</v-btn>
	        		</v-flex>
	        		<v-flex xs6 sm6 md6 center-align>
	        			<v-btn small font-heavy class="primary-color" flat @click="fn_done">Okay</v-btn>
	        		</v-flex>
	        	</v-layout>
		    </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

export default{
	data(){	
		return{
			dialog_tax_update: false,
            doNotShowAgain:false
		}
	},
	methods: {
		openDialogWeb: function () {	
			this.dialog_tax_update = true;
		},
		closeDialogWeb: function () {
			this.dialog_tax_update = false;
		},
        fn_done: function(){
            if(this.doNotShowAgain){
                localStorage.setItem('hide_old_tax_message', 1);
            }
            this.$parent.fn_closeDialog();
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_old_tax_update.vue